/* eslint-disable */

import { AppType } from '@/utils'
/**
 * @file IOS JSB库文件
 */
(function (window) {
  if(AppType.isInAndroid())return;//这里必须加判断，不然会影响Android上的微信自定义分享逻辑。

  if (window.BanmaAppBridge || /localhost/.test(window.location.hostname)) {
  	return "BanmaAppBridge already exists";
  }
  /**
   * 定义JSB
   */
  var BanmaAppBridge = {
      /**
       *jsb版本号
       *三位版本号：1.0.0，模块上传者能看到的部分为前两位
       *前两位标识Hybrid Api版本，最后一位标识分端bridge实现版本
       *如：Android和iOS当前jsb版本为1.0.1和1.0.2，表示当前两端的Hybrid Api都一致，
       *只是在内部bridge实现上Android迭代了1次，iOS迭代了2次
       */
      version : '1.1',
      /**
       * {boolean} 页面信息及DOM加载状态，全部加载完成为true，默认完成为false
       */
      _isAllReady : false
    },
    /**
     * {object} 存储返回函数
     */
    responseCallbacks = {},
    /**
     * 初始化callbackid值变量
     */
    uniqueId = 1,
    /**
     * {Array}
     */
    sendMessageQueue = [],

    messageHandlers = {};

  // 将BNJS暴露到window下：全局可使用，对旧版本向下兼容
  window.BanmaAppBridge = BanmaAppBridge;

  /**
   * Debug开发中的问题
   * @param    {Function}  callback(error) 出错后的回调，默认是alert
   */
  BanmaAppBridge.enableDebug = function (callback) {
    /**
     * @param errorMsg     {String}  错误信息
     * @param scriptURI    {String}  出错的文件
     * @param lineNum      {Long}    出错代码的行号
     * @param columnNum    {Long}    出错代码的列号
     */

    //console.log('Debug')
    window.onerror = function (errorMsg, scriptURI, lineNum, columnNum) {

      // 有callback的情况下，将错误信息传递到options.callback中
      if (typeof callback === 'function') {
        callback({
          message: errorMsg,
          script: scriptURI,
          line: lineNum,
          column: columnNum
        });
      } else {
        // 其他情况，都以alert方式直接提示错误信息
        var msgs = [];
        msgs.push("代码有错误。");
        msgs.push("\n错误信息：", errorMsg);
        msgs.push("\n出错文件：", scriptURI);
        msgs.push("\n出错位置：", lineNum + '行，' + columnNum + '列');
        // alert(msgs.join(''));
      }
    }

  };


  /**
   *  用于替代addJavascriptInterface的替代方案，返回值通过修改该iframe src实现
   */
  BanmaAppBridge.sendMessage = function(method, args, callback) {
    var callbackId;
    if (callback && typeof callback == 'function') {
      callbackId = 'banma_' + (uniqueId++) + '_' + new Date().getTime();
      responseCallbacks[callbackId] = callback;
    }
    args = args || {};
    args['callbackId'] = callbackId;
    args = JSON.stringify(args);

    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    iframe.src = 'jsapi://_?' + 'method=' + method + '&args=' + encodeURIComponent(args);
    setTimeout(function() {
      iframe.parentNode.removeChild(iframe);
    }, 0);
  };

  /**
   * 全局callback函数
   */
  BanmaAppBridge._callback = function (callbackId,responseData) {
    try {
      var callback = responseCallbacks[callbackId];
      if (!callback) {return}
      callback(responseData);
      responseCallbacks[callbackId] = null;
    } catch (e) {
      // alert(e);
    }
  };

  /**
   * 全局callback函数
   */
  BanmaAppBridge._responseback = function (callbackId,responseData) {
    try {
      var callback = responseCallbacks[callbackId];
      if (!callback) {return}
      callback(responseData);
    } catch (e) {
      // alert(e);
    }
  };

  /**
   * 头部右侧的icon响应事件
   */
  BanmaAppBridge._buttonAction = function(callbackId) {
    try {
      var callback = messageHandlers[callbackId];
      if (!callback) {return}
      callback();
    } catch (e) {
      // alert(e);
    }
  };

  BanmaAppBridge.enableCommentFeatureV2 = function(jsonString) {
    BanmaAppBridge.sendMessage("enableCommentFeature", JSON.parse(jsonString));
  };
  BanmaAppBridge.disableCommentFeature = function() {
    BanmaAppBridge.sendMessage("disableCommentFeature");
  };
  BanmaAppBridge.enableMenuBar = function(jsonString) {
    BanmaAppBridge.sendMessage("enableMenuBar", JSON.parse(jsonString));
  };
  BanmaAppBridge.exitPage = function() {
    BanmaAppBridge.sendMessage("exitPage");
  };
  BanmaAppBridge.callShare = function(jsonString) {
    BanmaAppBridge.sendMessage("callShare", JSON.parse(jsonString));
  };
  BanmaAppBridge.enableShare = function(jsonString) {
    BanmaAppBridge.sendMessage("enableShare", JSON.parse(jsonString));
  };
  BanmaAppBridge.disableShare = function() {
    BanmaAppBridge.sendMessage("disableShare");
  };
  BanmaAppBridge.setTitle = function(title) {
    BanmaAppBridge.sendMessage("setTitle", {title:title});
  };
  BanmaAppBridge.sendBroadcast = function(jsonString) {
    BanmaAppBridge.sendMessage("sendBroadcast", JSON.parse(jsonString));
  };
  BanmaAppBridge.showAt = function(nickName) {
    BanmaAppBridge.sendMessage("showAt", {nickName: nickName});
  };
  BanmaAppBridge.setAt = function(nickName) {
    BanmaAppBridge.sendMessage("setAt", {nickName: nickName});
  };
  BanmaAppBridge.goLogin = function() {
    BanmaAppBridge.sendMessage("goLogin");
  };
  BanmaAppBridge.openBrowser = function(link) {
    BanmaAppBridge.sendMessage("openBrowser", {link: link});
  };
  BanmaAppBridge.goContact = function(phoneNumber) {
    BanmaAppBridge.sendMessage("goContact", {phoneNumber: phoneNumber});
  };
  BanmaAppBridge.showShotBar = function() {
    BanmaAppBridge.sendMessage("showShotBar");
  };
  BanmaAppBridge.viewImages = function(jsonString) {
    BanmaAppBridge.sendMessage("viewImages", JSON.parse(jsonString));
  };
  BanmaAppBridge.enablePCHintButton = function() {//在app v2.5中增加
    BanmaAppBridge.sendMessage("enablePCHintButton");
  };
  BanmaAppBridge.getUserInfoFromNative = function(callback) {//在app v2.6中增加
    BanmaAppBridge.sendMessage("getUserInfoFromNative", null, callback);
  };
  BanmaAppBridge.getSystemInfoFromNative = function(callback) {//在app v2.11中增加
    BanmaAppBridge.sendMessage("getSystemInfoFromNative", null, callback);
  };
  BanmaAppBridge.trackEvent = function(jsonString) {
    BanmaAppBridge.sendMessage("trackEvent", JSON.parse(jsonString));
  };
  BanmaAppBridge.trackPageBegin = function(pageName) {
    BanmaAppBridge.sendMessage("trackPageBegin", {pageName:pageName});
  };
  BanmaAppBridge.trackPageEnd = function(pageName) {
    BanmaAppBridge.sendMessage("trackPageEnd", {pageName:pageName});
  };
  BanmaAppBridge.getDeviceId = function(callback) {
    BanmaAppBridge.sendMessage("getDeviceId", null, callback);
  };
  BanmaAppBridge.trackPageOn = function(pageName) {
    BanmaAppBridge.sendMessage("trackPageOn", {pageName:pageName});
  };
  BanmaAppBridge.createLiveBroadcastOrder = function(orderId) {
    BanmaAppBridge.sendMessage("createLiveBroadcastOrder", {orderId:orderId});
  };

  /**
   * 对象简单继承，后面的覆盖前面的，继承深度：deep=1
   * @private
   */
  var _extend = function () {
    var result = {}, obj, k;
    for (var i = 0, len = arguments.length; i < len; i++) {
      obj = arguments[i];
      if (typeof obj === 'object') {
        for (k in obj) {
          obj[k] && (result[k] = obj[k]);
        }
      }
    }
    return result;
  };

  return "success";

})(window);



// WEBPACK FOOTER //
// ./src/libs/ios-app-bridge.js